export const baseApiUrl = import.meta.env.VITE_API_BASE_URL;

export const baseAutomationUrl = import.meta.env.VITE_AUTOMATION_BASE_URL;

export const secretKey = import.meta.env.VITE_THERAPIST_SECRET_KEY;

export const keycloakAuthUrl = import.meta.env.VITE_KEYCLOAK_AUTH_URL;

export const splitIoAuthorizationKey = import.meta.env.VITE_SPLIT_IO_KEY;

export const serviceLogMatrixVisibilityTreatment = 'Service-Log-Matrix-visibility';

export const deailySessionNoteTreatment = 'THIN-3938-dynamic-forms';

export const goalBankTreatment = 'THIN-4032_goal_bank';

export const deleteDocumentAlertTreatment = 'THIN-4275-delete-document-alert';

export const autoProgressNoteTreatment = 'THIN-4366-auto-progress-note';

export const prefillIdCPTICDTreatment = 'THIN-4371-add-prefillId-CPT-ICD-edit-document';

export const mdsCommunicationTreatment = 'THIN-4372-mds-communication';

export const reFormsPtEvalTreatment = 'THIN-4541-reforms';

export const reFormsOtEvalTreatment = 'Reforms-OT-Eval';

export const reFormsSlpEvalTreatment = 'BRK-370-SLP-eval';

export const reFormsPtProgressNoteTreatment = 'BRK-505-pt-progress-note';

export const reFormsOtProgressNoteTreatment = 'BRK-505-ot-progress-note';

export const reFormsSlpProgressNoteTreatment = 'BRK-505-slp-progress-note';

export const reFormsOtRecertTreatment = 'ot-recertification';

export const reFormsPtRecertTreatment = 'pt-recertification';

export const reFormsSlpRecertTreatment = 'slp-recertification';

export const reFormsOtDischargeTreatment = 'ot-discharge';

export const reFormsPtDischargeTreatment = 'pt-discharge';

export const reFormsSlpDischargeTreatment = 'slp-discharge';

export const reFormsMdsCommunicationTreatment = 'Reforms-MDS-Communication';

export const reFormsDraftDocumentList = 'Draft-Document-List';

export const reFormsCompactStylesTreatment = 'ReForm-Compact-Styles';

export const copyCodeDescriptionTreatment = 'THIN-4080-copy-description';

export const clockInActivityType = 'THIN-4807-activity-type';

export const isSchedularUIImprovement = 'THIN-4807-scheduler-ui-improvement';

export const reformUsePhysicianTableV2 = 'Reform-use-physician-table-version';

export const therapyPlanning2_0 = 'THIN-4421-therapy-planning-2';

export const therapyPlanningTemplate = 'THIN-5285-therapy-templates';

export const recheckDischarge = 'THIN-5585-recheck-discharge';

export const singleSignatureWorkflow = 'THIN-5503-single-signature-workflow';

export const DocDuePnAlert = 'docs-due-fsm';
